import { EventBus } from '../../helpers';

type RouterNonUiEvents = {
  routePopped: [pathname: string];
};

class RouterNonUiEventBus extends EventBus<RouterNonUiEvents> {}

export const routerNonUiEventBus = new RouterNonUiEventBus();
